'use client';

import { useAuthStore } from '@/stores/authStore';
import { useState } from 'react';

import { KagemaneStudio } from './KagemaneStudio';

export function KagemaneLibrary({
  onBack,
}: {
  onBack: () => void;
}) {
  const userId = useAuthStore((state) => state.user?.id);
  const [identity, setIdentity] = useState({ owner: userId, epoch: 0 });
  if (identity.owner !== userId) {
    // Recovery of the first account must retain the guest's authored state.
    // Logout or switching an established account clears all private materials
    // synchronously, before the next account can render this studio.
    setIdentity({ owner: userId, epoch: identity.epoch + (identity.owner ? 1 : 0) });
  }
  // Route shells own navigation height; keep both standalone and embedded studios
  // inside their available space instead of subtracting a removed desktop top bar.
  return (
    <section
      className="flex h-full min-h-0 flex-col overflow-hidden bg-white"
      aria-labelledby="kagemane-title"
      data-kagemane-library
    >
      <KagemaneStudio key={identity.epoch} onBack={onBack} />
    </section>
  );
}
